import React from "react";

function Privacy() {
  return <div>Privacy Policy</div>;
}

export default Privacy;
